export default __webpack_public_path__ + "static/media/Local2.24591747.jpeg";